export default {
  back: 'Back',
  resendCode: 'Resend code',
  resendCodeFailure: 'Please try a bit later',
  resendCodeSuccess: `We will resend the code in {{seconds}} seconds. \n\nNot getting the code? Double check the spelling of the email address you entered. Or check your filters and tabs.`,
};
